import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import Reconciliation from 'pages/Reconciliation/Reconciliation'

export const Route = createFileRoute('/_auth/_global/reconciliation')({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.CABLE_ADMIN,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: Reconciliation,
})
